module.exports = __webpack_public_path__ + "prod/1.42.2/img/power3.298da287.png";